export const SwitchToggleFourOptionEnum = {
    Correct: "Correct",
    InCorrect: "InCorrect",
    NotChecked: "NotChecked",
    Disabled: "Disabled",
}